import { FormError } from '@/components/shared/errors'
import { IOptions, IPagination } from './types'

export type REQUEST_TYPES = 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE'
export type REST_OPTIONS = 'LIST' | 'CREATE' | 'RETRIEVE' | 'UPDATE' | 'PARTIAL_UPDATE' | 'DELETE' | 'BULK_DELETE'
export interface API_CONFIG {
  url: string
  headers?: Record<string, any>
  options?: REQUEST_TYPES[]
  method?: REQUEST_TYPES
}

export interface API_PARAMS {
  urlParams?: Record<string, any>
  queryParams?: Record<string, any>
  body?: Record<string, any>
  headers?: Record<string, any>
}

export const getRequestConfig = (restOption: REST_OPTIONS, apiConfig: API_CONFIG, endpoint: string) => {
  const REST_OPTIONS: Record<REST_OPTIONS, API_CONFIG> = {
    LIST: {
      url: `${endpoint}${apiConfig.url}`,
      method: 'GET'
    },
    CREATE: {
      url: `${endpoint}${apiConfig.url}`,
      method: 'POST'
    },
    RETRIEVE: {
      url: `${endpoint}${apiConfig.url}{resource_id}/`,
      method: 'GET'
    },
    UPDATE: {
      url: `${endpoint}${apiConfig.url}{resource_id}/`,
      method: 'PUT'
    },
    PARTIAL_UPDATE: {
      url: `${endpoint}${apiConfig.url}{resource_id}/`,
      method: 'PATCH'
    },
    DELETE: {
      url: `${endpoint}${apiConfig.url}{resource_id}/`,
      method: 'DELETE'
    },
    BULK_DELETE: {
      url: `${endpoint}${apiConfig.url}`,
      method: 'DELETE'
    }
  }
  const config: API_CONFIG = {
    url: REST_OPTIONS[restOption].url,
    method: REST_OPTIONS[restOption].method,
    headers: apiConfig.headers
  }
  return config
}

export const setTokenConf = (apiConfig: API_PARAMS, token: string) => {
  if (apiConfig.headers) {
    apiConfig.headers = apiConfig.headers || {}
  }
  if (token) {
    apiConfig.headers = {
      Authorization: `Token ${token}`
    }
  }

  return apiConfig
}

interface APIResponse extends Response {
  result: [] | Record<string, unknown> | IOptions[]
  pagination?: IPagination
}

export const request = async (apiConfig: API_CONFIG, params: API_PARAMS = {}) => {
  const queryParams = new URLSearchParams(params.queryParams).toString()
  let url = apiConfig.url + (queryParams ? '?' + queryParams : '')
  if (params.urlParams) {
    for (const key in params.urlParams) {
      url = url.replace(`{${key}}`, params.urlParams[key])
    }
  }
  let headers = apiConfig.headers
  if (params.headers) {
    headers = { ...headers, ...params.headers }
  }
  let body: Record<string, any> = {}
  if (params.body) {
    body = params.body
  }
  let fetchParams: RequestInit = {
    method: apiConfig.method,
    headers: {
      ...headers,
    },
    cache: 'no-cache'
  }
  let parsedBody: BodyInit | null | undefined

  if (apiConfig.headers && apiConfig.headers['Content-Type'] === 'application/json') {
    parsedBody = JSON.stringify(body)
  } else {
    /* Check if formData is accesible */
    if (typeof FormData === 'undefined') {
      return {}
    } else {
      parsedBody = new FormData()
      // eslint-disable-next-line no-restricted-syntax, guard-for-in
      for (const key in body) {
        parsedBody.append(key, body[key] as string | Blob)
      }
    }
  }

  if (apiConfig.method === 'GET') {
    parsedBody = undefined
  } else {
    fetchParams.body = parsedBody
  }

  const response = fetch(url, fetchParams).then(async res => {
    if (res.status < 200 || res.status >= 300) {
      const responseError = await res.json()
      throw new FormError('Error', responseError)
    }

    try {
      const result = await res.json()
      return result
    } catch (error) {
      return res
    }
  })
  return await response
}
